import { Pipe } from '@angular/core';

import ethPrices from '@/constants/eth-prices.json';
import { environment } from 'src/environments/environment';
import { formatUnits } from 'viem';

// Type the ethPrices as a 2D array of numbers
const ethPricesData = ethPrices as unknown as [number, number][];

@Pipe({
  standalone: true,
  name: 'usd',
})
export class UsdPipe {
  transform(ethValue: number, ...args: any[]): number {
    const [ usd ] = args;
    const usdDecimals = formatUnits(usd, 8);
    return ethValue * Number(usdDecimals);
  }

  findClosestValue(targetTimestamp: number): number {
    const data = ethPricesData;

    let left = 0;
    let right = data.length - 1;

    if (data.length === 0) {
      throw new Error('The data array is empty.');  
    }

    // If the target timestamp is outside the range of the timestamps in the data, return the closest edge value.
    if (targetTimestamp <= data[left][0]) return data[left][1];
    if (targetTimestamp >= data[right][0]) return data[right][1];

    while (left <= right) {
      const mid = Math.floor((left + right) / 2);
      const currentTimestamp = data[mid][0];

      // Check if the current timestamp is the target; or if the target is between the current and its neighbors, then find the closest.
      if (currentTimestamp === targetTimestamp) {
        return data[mid][1];
      } else if (targetTimestamp < currentTimestamp) {
        if (mid > 0 && targetTimestamp > data[mid - 1][0]) {
          // Decide whether the current or the previous timestamp is closer to the target.
          return Math.abs(data[mid][0] - targetTimestamp) <
          Math.abs(data[mid - 1][0] - targetTimestamp)
              ? data[mid][1]
              : data[mid - 1][1];
        }
        right = mid - 1;
      } else {
        if (mid < data.length - 1 && targetTimestamp < data[mid + 1][0]) {
          // Decide whether the current or the next timestamp is closer to the target.
          return Math.abs(data[mid][0] - targetTimestamp) <
          Math.abs(data[mid + 1][0] - targetTimestamp)
              ? data[mid][1]
              : data[mid + 1][1];
        }
        left = mid + 1;
      }
    }

    // Fallback, should technically not reach here if data array contains more than one element.
    return data[left][1];
  }
}
